class VideoModal extends HTMLElement {
  constructor() {
    super();
    this.player = null;
    this.lastTrigger = null;
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return;
    }
    this.player = this.querySelector('[data-video-container]');
    document.addEventListener('click', this.onClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  onClick(e) {
    const trigger = e.target.closest('[data-video-modal-trigger]');
    if (trigger) {
      e.preventDefault();
      this.lastTrigger = trigger;
      this.open(trigger.dataset);
      return;
    }
    if (e.target.closest('[data-modal-close]') && this.contains(e.target)) {
      this.close();
    }
  }

  onKeydown(e) {
    if (e.key === 'Escape' && !this.hidden) {
      this.close();
    }
  }

  open({ videoUrl, videoFile, videoTitle }) {
    const html = this.buildEmbed(videoUrl, videoFile, videoTitle || '');
    if (!html) return;
    this.player.innerHTML = html;
    this.hidden = false;
    document.body.classList.add('overflow-hidden');
    const closeBtn = this.querySelector('[data-modal-close]');
    if (closeBtn) closeBtn.focus();
  }

  close() {
    this.player.innerHTML = '';
    this.hidden = true;
    document.body.classList.remove('overflow-hidden');
    if (this.lastTrigger) {
      this.lastTrigger.focus();
      this.lastTrigger = null;
    }
  }

  buildEmbed(url, file, title) {
    const safeTitle = this.escapeAttr(title);
    if (file) {
      const src = this.escapeAttr(file);
      return `<video src="${src}" controls autoplay playsinline title="${safeTitle}"></video>`;
    }
    const id = this.parseId(url);
    if (id && id.kind === 'youtube') {
      return `<iframe src="https://www.youtube.com/embed/${id.value}?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media; fullscreen" allowfullscreen title="${safeTitle}"></iframe>`;
    }
    if (id && id.kind === 'vimeo') {
      return `<iframe src="https://player.vimeo.com/video/${id.value}?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen title="${safeTitle}"></iframe>`;
    }
    return '';
  }

  parseId(url) {
    if (!url) return null;
    const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if (yt) return { kind: 'youtube', value: yt[1] };
    const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return { kind: 'vimeo', value: vm[1] };
    return null;
  }

  escapeAttr(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
}

customElements.define('video-modal', VideoModal);
